module.exports = __webpack_public_path__ + "static/arcadium-sm-521ecd3448f7639f31f2599a6b630dba.jpg";